import Vue from 'vue'
import App from './App.vue'
import store from './store'

import "./css/globalStyles.css"

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')

console.log('© Copyright Berg Enterprises, LLC 2020 | Site designed and developed by Adam Morgan (adam-morgan.com)')